import { useLayoutEffect, useRef } from 'react';
import Lenis from 'lenis';
import AOS from 'aos';

const SmoothScroll = ({ children }) => {
    const lenisRef = useRef(null);

    useLayoutEffect(() => {
        const lenis = new Lenis({
            duration: 1.5,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            orientation: 'vertical',
            gestureOrientation: 'vertical',
            smoothWheel: true,
            wheelMultiplier: 1,
            touchMultiplier: 2,
            infinite: false,
        });

        lenisRef.current = lenis;
        window.lenis = lenis;

        // Synchronize AOS with Lenis
        lenis.on('scroll', () => {
            AOS.refresh();
        });

        // Handle content resize (important for dynamic content)
        const resizeObserver = new ResizeObserver(() => {
            lenis.resize();
        });
        resizeObserver.observe(document.body);

        // Intercept anchor links for smooth scrolling
        const handleAnchorClick = (e) => {
            const target = e.target.closest('a');
            if (target && target.hash && target.hash.startsWith('#')) {
                const element = document.querySelector(target.hash);
                if (element) {
                    e.preventDefault();
                    lenis.scrollTo(element);
                }
            }
        };
        window.addEventListener('click', handleAnchorClick);

        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }

        requestAnimationFrame(raf);

        return () => {
            window.removeEventListener('click', handleAnchorClick);
            resizeObserver.disconnect();
            lenis.destroy();
            window.lenis = null;
        };
    }, []);

    return <>{children}</>;
};

export default SmoothScroll;
